/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var ERROR = 'too_short';
/**
 * Creates validator for min length check
 *
 * @function minLength
 * @param {int} minLength Min length threshold
 * @return {validator} minLength validator
 */

export default function minLength(minLength) {
  return function (value) {
    if (value && value.length < minLength) return ERROR;
    return null;
  };
}